// src/pages/NotFound.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

import NotFoundImage from "../../assets/Monster 404 Error-cuate.png"; 

export const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-4">

            {/* Image */}
            <img
                src={NotFoundImage}
                alt="404 Not Found"
                className="w-[350px] md:w-[450px] mb-6"
            />

            {/* Title */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
                Ooops! Page Not Found
            </h1>

            {/* Description */}
            <p className="text-gray-500 mt-3 max-w-md">
                The page you’re looking for doesn’t exist or may have been moved.
                Let’s get you back to learning.
            </p>

            {/* Button */}
            <button
                onClick={() => navigate("/")}
                className="mt-6 bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-xl font-medium transition"
            >
                Go to Home
            </button>

        </div>
    );
};